// extracted by mini-css-extract-plugin
export default {"page":"styles_page__zyLdQ"};